import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const SupportMenu = () => {
	const location = useLocation();

	const isActive = path => location.pathname.startsWith(path);

	return (
		<>
			<li className={isActive('/support/chat') ? 'active' : ''}>
				<Link to="/support/chat">
					<div className="icon-w">
						<div className="os-icon os-icon-mail-18" />
					</div>
					<span>Patient Chat</span>
				</Link>
			</li>
		</>
	);
};

export default SupportMenu;
